import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.643 5.614a.75.75 0 0 1-.257 1.03L8.458 12l8.928 5.357a.75.75 0 1 1-.772 1.286l-10-6a.75.75 0 0 1 0-1.286l10-6a.75.75 0 0 1 1.03.257",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }